export default [{
	path: '/',
	name: 'home',
	meta: {
		title: '泉州市洛江区万安街道杜剑锋专业设计工作室（个体工商户）',
	},
	component: () => import('@/views/home'),
}]
